// -------------------------------
// FINANCIAL YEAR INTERFACES
// -------------------------------
export interface PendingFinancialYear {
    id?: number;
    name?: string;
    start_date?: string;
    end_date?: string;
    CompanyID?: number;
}

export interface PendingUpdateFinancialYear {
    awaitingName?: boolean;
}

export const startCreateFinancialYearFlow = (
  setPendingFY: (data: PendingFinancialYear | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void,
  nameFromIntent?: string
) => {
  if (nameFromIntent) {
    setPendingFY({ name: nameFromIntent });

    pushAIChat(`Got it! When does "${nameFromIntent}" start?`);
    speak(`When does ${nameFromIntent} start?`);
    return;
  }

  setPendingFY({});
  pushAIChat("What should the financial year name be? (example: fy_2025)");
  speak("What should the financial year name be?");
};


export const processPendingFinancialYear = (
  text: string,
  pendingFY: PendingFinancialYear,
  setPendingFY: (data: PendingFinancialYear | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void,
  companyId?: number
) => {

  if (!companyId) {
    console.log(companyId, 'company id')
    pushAIChat("Company context is missing. Please reload the page.");
    speak("Company context is missing.");
    setPendingFY(null);
    return;
  }

  // STEP 1 — NAME
  if (!pendingFY.name) {
    const name = text.trim().toLowerCase();

    if (!/^fy_\d{4}$/.test(name)) {
      pushAIChat("Please provide a valid name like fy_2025.");
      speak("Please provide a valid financial year name.");
      return;
    }

    setPendingFY({ ...pendingFY, name, CompanyID: companyId });
    pushAIChat("What is the start date?");
    speak("What is the start date?");
    return;
  }

  // STEP 2 — START DATE
  if (!pendingFY.start_date) {
    setPendingFY({ ...pendingFY, start_date: text });
    pushAIChat("What is the end date?");
    speak("What is the end date?");
    return;
  }

  // STEP 3 — END DATE (FINAL)
  if (!pendingFY.end_date) {
    pushAIChat(`Creating financial year "${pendingFY.name}"...`);
    speak(`Creating financial year ${pendingFY.name}`);

    window.dispatchEvent(
      new CustomEvent("ai-create-financial-year", {
        detail: {
          name: pendingFY.name,
          start_date: pendingFY.start_date,
          end_date: text,
          companyId
        }
      })
    );

    setPendingFY(null);
  }
};


export const startUpdateFinancialYearFlow = (
    setPendingFY: (data: PendingFinancialYear | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    existingFY?: any
) => {
    if (!existingFY) {
        pushAIChat("Which financial year do you want to update?");
        speak("Which financial year do you want to update?");
        return;
    }

    setPendingFY({
        id: existingFY.id,
        name: existingFY.name,
        start_date: existingFY.start_date,
        end_date: existingFY.end_date,
        CompanyID: existingFY.CompanyID
    });

    pushAIChat("What should be the new start date?");
    speak("What should be the new start date?");
};

export const processPendingUpdateFinancialYear = (
    text: string,
    pendingFY: PendingFinancialYear,
    setPendingFY: (data: PendingFinancialYear | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — START DATE
    if (!pendingFY.start_date) {
        setPendingFY({ ...pendingFY, start_date: text });

        pushAIChat("What should be the new end date?");
        speak("What should be the new end date?");
        return;
    }

    // STEP 2 — END DATE (FINAL)
    if (!pendingFY.end_date) {
        pushAIChat(`Updating financial year "${pendingFY.name}"...`);
        speak(`Updating financial year ${pendingFY.name}`);

        window.dispatchEvent(
            new CustomEvent("ai-update-financial-year", {
                detail: {
                    id: pendingFY.id,
                    name: pendingFY.name,
                    start_date: pendingFY.start_date,
                    end_date: text,
                    CompanyID: pendingFY.CompanyID
                }
            })
        );

        setPendingFY(null);
    }
};

